const DataFilterListItem = ({ item, onClick, checked }) => {
    return (
        <li>
            <button
                className={`rounded py-1 sm:py-2 px-4 border text-xs font-semibold inline-block
                ${
                    checked
                        ? "bg-gradient-to-br from-primary-300 to-primary-400 text-primary-950 border-primary-900 dark:text-primary-400 dark:border-primary-400 dark:from-neutral-800 dark:to-neutral-900 hover:dark:border-primary-300  hover:dark:text-primary-300"
                        : "text-neutral-800 border-neutral-300 bg-gradient-to-br from-neutral-100 to-neutral-200 dark:hover:border-neutral-400 hover:dark:text-neutral-400 dark:from-neutral-900 dark:to-neutral-900 dark:text-neutral-400 dark:border-neutral-600"
                }`}
                onClick={() => onClick(item)}
            >
                {item}
            </button>
        </li>
    )
}

export default DataFilterListItem
